<template slot-scope="slotProps">
	<li class="v-contextual__options__option" :class="classes" v-if="!hidden" :disabled="disabled">
		<a v-if="navigateTo" :href="navigateTo">
			<slot/>
		</a>
		<router-link v-if="routeTo" :to="routeTo">
			<slot/>
		</router-link>
		<button v-if="!navigateTo && !routeTo" v-on="handlers">
			<slot/>
		</button>
	</li>
</template>
<script>
export default {
	props: {
		navigateTo: {
			type: String,
			default() {
				return null;
			}
		},
		routeTo: {
			type: Object,
			default() {
				return null;
			}
		},
		events: {
			type: Object,
			default() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: function () {
				return false;
			}
		},
		hidden: {
			type: Boolean,
			default: function () {
				return false;
			}
		},
	},

	computed: {
		classes() {
			return {
				"v-contextual__options__option--disabled": this.disabled
			};
		},
		handlers() {
			return _.mapValues(this.$listeners, function (a, b) {
				return this.handleEvent;
			}.bind(this));
		},
	},

	methods: {
		handleEvent(event) {
			if (this.disabled) {
				return;
			}

			this.$parent.toggle();
			this.$listeners[event.type].call(this, event);
		},
	},

	created() {
		this.$parent.addOption(this);
	},

	destroyed() {
		this.$parent.removeOption(this);
	}
};
</script>
